module.exports = __webpack_public_path__ + "img/list-back-1.b6c4b358.gif";